import { render } from "./AppRadio.vue?vue&type=template&id=834c138c"
import script from "./AppRadio.vue?vue&type=script&lang=js"
export * from "./AppRadio.vue?vue&type=script&lang=js"

import "./AppRadio.vue?vue&type=style&index=0&id=834c138c&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__